import { apiGet, apiPost, apiPut, apiPatch, apiDelete, apiUpload, apiBuildUrl } from './client';

export const createEncounter = (patientId, visitDate, assignedPhysicianId) =>
    apiPost('api/encounters', { patientId, visitDate, assignedPhysicianId });

// Physicians a draft can be assigned to (current branch). Gated on
// encounters:write server-side.
export const listAssignablePhysicians = () =>
    apiGet('api/encounters/physicians');

export const getEncounter = (id) =>
    apiGet(`api/encounters/${id}`);

export const listEncountersByPatient = (patientId) =>
    apiGet(`api/encounters/by-patient/${patientId}`);

export const listEncounters = (params) =>
    apiGet('api/encounters', params);

export const updateEncounter = (id, payload) =>
    apiPut(`api/encounters/${id}`, payload);

export const finalizeEncounter = (id) =>
    apiPost(`api/encounters/${id}/finalize`, {});

// Reopen a signed report for correction. `reason` is required and lands in
// the encounter's permanent amendment history + the audit log.
export const amendEncounter = (id, reason) =>
    apiPost(`api/encounters/${id}/amend`, { reason });

// Re-sign an amended report and close the open amendment.
export const completeAmendment = (id) =>
    apiPost(`api/encounters/${id}/amend/complete`, {});

export const uploadPreviousInvestigation = (id, file, meta = {}) => {
    const form = new FormData();
    form.append('file', file);
    if (meta.label) form.append('label', meta.label);
    if (meta.date) form.append('date', meta.date);
    if (meta.notes) form.append('notes', meta.notes);
    return apiUpload(`api/encounters/${id}/previous-investigations`, form);
};

export const downloadPreviousInvestigationUrl = (id, attachmentId) =>
    apiBuildUrl(`api/encounters/${id}/previous-investigations/${attachmentId}`);

// General document attachments on an encounter
export const uploadEncounterDocument = (id, file, label, includeInReport = false) => {
    const form = new FormData();
    form.append('file', file);
    if (label) form.append('label', label);
    if (includeInReport) form.append('includeInReport', 'true');
    return apiUpload(`api/encounters/${id}/documents`, form);
};

// Append (or stop appending) this document's pages to the visit summary.
export const setEncounterDocumentInclusion = (id, docId, includeInReport) =>
    apiPatch(`api/encounters/${id}/documents/${docId}`, { includeInReport });

export const deleteEncounterDocument = (id, docId) =>
    apiDelete(`api/encounters/${id}/documents/${docId}`);

export const encounterDocumentDownloadUrl = (id, docId) =>
    apiBuildUrl(`api/encounters/${id}/documents/${docId}`);

// Aggregate every document attached to any encounter for this patient
export const listPatientDocuments = (patientId) =>
    apiGet(`api/encounters/by-patient/${patientId}/documents`);
